import { request } from '@/shared/api/request'

export const send = (data) => {
	return request({ url: `assessment/contract/send`, method: 'POST', data })
}

export const xml = (data) => {
	return request({ url: `assessment/contract/xml`, method: 'POST', data })
}
